module.exports = __webpack_public_path__ + "static/media/wp_city.12bb9a60.jpg";